/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { useQueryState } from "~/hooks";
import { getFirstItem } from "~/tools";
import { ChartOption, ChartsQueryState, ChartType, Period } from "../types";

type Props = {
  period: Period;
  chartOptions: ChartOption[];
};

export function useCostAnalysis({ period, chartOptions }: Props) {
  const { state } = useQueryState<ChartsQueryState>();
  const queryStateChartType = chartOptions.find(
    ({ value }) => value === state.chartType
  );
  const [chartType, setChartType] = useState<{
    value: ChartType;
    label: ChartType;
  }>(queryStateChartType ?? getFirstItem(chartOptions));

  function isChartVisible(chart: ChartType) {
    return chart === chartType.value || chart === queryStateChartType?.value;
  }

  const hasFooter = chartType.value !== ChartType.ACCUMULATED_COST;

  const showCostTable = [Period.QUARTER, Period.YEAR, Period.RANGE].includes(
    period
  );

  return {
    chartType: queryStateChartType ?? chartType,
    setChartType,
    hasFooter,
    isChartVisible,
    showCostTable,
  };
}
